import React from "react";
import { useIntl } from "react-intl";
import { string as yupString } from "yup";
import TextInputField from "./text-input-field";
import sharedMessages from "../../../../shared-messages";

const UsernameField = () => {
  const { formatMessage } = useIntl();

  const usernameValidationSchema = yupString().required(
    formatMessage(sharedMessages.requireUsername)
  );

  return (
    <TextInputField
      id="username"
      className="username"
      name="userName"
      label={formatMessage(sharedMessages.username)}
      validationSchema={usernameValidationSchema}
      aria-required="true"
    />
  );
};

export default UsernameField;
